import { Injectable, OnDestroy } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from "@angular/common/http";

import {
  catchError,
  Observable,
  switchMap,
  throwError,
  BehaviorSubject,
  filter,
  take,
  EMPTY
} from "rxjs";

import { AuthenticationService } from "../services/auth.service";
import { AppToastService } from "../services/app-toast.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Injectable()
export class JwtInterceptor implements HttpInterceptor, OnDestroy {

  private isRefreshing = false;

  private refreshTokenSubject =
    new BehaviorSubject<boolean | null>(null);

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private toast: AppToastService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Ignorar requests fora da API
    if (!request.url.startsWith(environment.url)) {
      return next.handle(request);
    }

    // Sempre enviar cookies
    request = this.addCredentials(request);

    return next.handle(request).pipe(

      catchError((error: HttpErrorResponse) => {

        // NÃO tentar refresh se já for refresh
        if (request.url.includes("/refresh")) {

          this.isRefreshing = false;

          this.refreshTokenSubject.next(false);

          this.redirectToLogin();

          return EMPTY;

        }

        // NÃO tentar refresh se for login
        if (request.url.includes("/login")) {
          return throwError(() => error);
        }

        // NÃO tentar refresh se for logout
        if (request.url.includes("/logout")) {

          this.redirectToLogin();

          return EMPTY;

        }

        // Tentar refresh apenas para 401
        if (error.status === 401) {
          return this.handle401Error(request, next);
        }

        return throwError(() => error);

      })

    );

  }



  private handle401Error(
  request: HttpRequest<any>,
  next: HttpHandler
): Observable<HttpEvent<any>> {

  if (!this.isRefreshing) {

    this.isRefreshing = true;

    this.refreshTokenSubject.next(null);

    return this.authService.getRefreshToken().pipe(

      switchMap(() => {

        this.isRefreshing = false;

        this.refreshTokenSubject.next(true);

        return next.handle(this.addCredentials(request));

      }),

      catchError(() => {

        this.isRefreshing = false;

        this.refreshTokenSubject.next(false);

        this.redirectToLogin(true);

        return EMPTY;

      })

    );

  }

  return this.refreshTokenSubject.pipe(

    filter(result => result !== null),

    take(1),

    switchMap(success => {

      if (!success) {

        return EMPTY;

      }

      return next.handle(this.addCredentials(request));

    })

  );

}




  private redirectToLogin(showToast = false): void {

    this.isRefreshing = false;

    if(showToast){ 
      this.toast.show("Atenção", "Sessão expirada", false);
    }
      
    this.authService.logout();

   this.router.navigate(["/account/login"]);

  }

  private addCredentials(
    request: HttpRequest<any>
  ): HttpRequest<any> {

    return request.clone({
      withCredentials: true
    });

  }

  ngOnDestroy(): void {

    this.refreshTokenSubject.complete();

  }

}